<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" width="28%">
        <el-form ref="form" :model="form" :rules="rules" label-width="88px">
            <el-form-item label="物流公司:" prop="logistics_name">
                <!-- <el-input v-model="form.logistics_name" :disabled="!isEdit"></el-input> -->
                <el-select v-model="form.logistics_name" placeholder="请选择物流公司" :disabled="!isEdit">
                    <el-option :label="item.name" :value="item.name" v-for="item, index in logisticsList" :key="index" />
                </el-select>
            </el-form-item>
            <el-form-item label="物流单号:" prop="logistics_number">
                <el-input v-model="form.logistics_number" :disabled="!isEdit"></el-input>
            </el-form-item>
            <el-row v-if="isEdit" type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" @click="submit">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { lucky } from '@/api/draw.js'

export default {
    data: () => ({
        rules: {
            logistics_name: [{ required: true, message: "请输入物流公司名称", trigger: 'blur' }],
            logistics_number: [{ required: true, message: "请输入物流单号", trigger: 'blur' }],
        },
        form: {
            logistics_name: '',
            logistics_number: ''
        },
        title: '',
        logisticsList: [
            {
                name: '日本郵便',
                id: 1,
            },
            {
                name: 'ヤマト運輸',
                id: 2,
            },
            {
                name: '佐川急便',
                id: 3,
            },
            {
                name: '其他',
                id: 4,
            },
        ]
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        // type: {
        //     default: 'edit',
        //     type: String
        // },
        // 编辑的数据
        logisticsData: {
            type: Object,
            required: true
        },
        //是否可以编辑
        isEdit: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            // const handlers = {
            //     add: () => {
            //         this.form = {
            //             company: '',
            //             order_number: ''
            //         }
            //     },
            //     edit: () => {
            //         const { company, order_number } = this.editData
            //         this.form = {
            //             company:company||'',
            //             order_number:order_number||''
            //         }
            //     }
            // }

            // handlers[this.type]()
            const { logistics_name, logistics_number } = this.logisticsData
            console.log('初始化', logistics_name, logistics_number)
            this.form = {
                logistics_name: logistics_name || '',
                logistics_number: logistics_number || ''
            }
        },
        submit() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    console.log(this.logisticsData, '1234')
                    lucky.delivery({ id: this.logisticsData.id, ...this.form }).then(res => {
                        console.log('请求成功', res)
                        this.$message({
                            message: '发货成功',
                            type: 'success'
                        })
                        this.trunOff()
                        this.$emit('success')
                    }).catch(err => {
                        console.log('失败', err)
                    })
                }
            })
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        // title() {
        //     const { type } = this

        //     const title = {
        //         add: "填写物流信息",
        //         edit: "编辑物流信息"
        //     }

        //     return title[type]
        // }
    },
    watch: {
        show(newVal) {
            console.log('触发变化')
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        },
        isEdit: {
            handler(nval) {
                this.title = `${nval ? '填写' : '查看'}物流信息`
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped></style>